
























import { Component, Prop, Vue } from 'vue-property-decorator';

import Swiper, { SwiperOptions, Pagination } from 'swiper';

import VideoPlayer from '@/components/common/VideoPlayer.vue';

Swiper.use([Pagination]);

const SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 'auto',
  centeredSlides: true,
  shortSwipes: false,
  slideToClickedSlide: true,
  longSwipesRatio: 0.2,
  spaceBetween: 80,
};

@Component({
  components: { VideoPlayer },
})
export default class GamePreviewSlides extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly slides!: Array<SlideConfig>;

  swiper!: Swiper;

  mounted() {
    this.swiper = new Swiper(this.$refs.swiper as HTMLElement, {
      ...SWIPER_OPTIONS,
      pagination: {
        el: this.$refs.pagination as HTMLElement,
        clickable: true,
      },
    });
  }

  beforeDestroy() {
    this.swiper.destroy();
  }
}
